export default __webpack_public_path__ + "static/media/You caught me in the act.38e63f8b.mp4";